import _ from 'lodash';
export interface AppConfig {
  type: 'local' | 'dev' | 'staging' | 'testing' | 'demo' | 'prod';
  publicUrl: string;
  baseUrl: string;
  gaTrackingId: string;
  pollingInterval: number;
}

type ShortConfig = Omit<AppConfig, 'gaTrackingId' | 'pollingInterval'>;

const ENV = process.env.REACT_APP_STAGE;
const ENV_PRINT = ENV === null ? 'null' : ENV === undefined ? 'undefined' : ENV;

// use this constant only if you are not using any kind of proxy-server
// baseUrl: 'http://localhost:8080';
const localConfig: ShortConfig = {
  type: 'local',
  publicUrl: 'http://localhost',
  baseUrl: 'http://localhost/api',
};
const devConfig: ShortConfig = {
  type: 'dev',
  publicUrl: 'http://localhost',
  baseUrl: 'http://localhost/api',
};
const stagingConfig: ShortConfig = {
  type: 'staging',
  publicUrl: 'https://staging-ax.healthstrategies.com',
  baseUrl: 'https://staging-ax.healthstrategies.com/server',
};
const testingConfig: ShortConfig = {
  type: 'testing',
  publicUrl: 'https://testing-ax.healthstrategies.com',
  baseUrl: 'https://testing-ax.healthstrategies.com/server',
};

const demoConfig: ShortConfig = {
  type: 'demo',
  publicUrl: 'https://demo-ax.healthstrategies.com',
  baseUrl: 'https://demo-ax.healthstrategies.com/server',
};
const prodConfig: ShortConfig = {
  type: 'prod',
  publicUrl: 'https://ax.healthstrategies.com',
  baseUrl: 'https://ax.healthstrategies.com/server',
};

const getConfig = (): ShortConfig => {
  switch (ENV) {
    case 'local':
      return localConfig;
    case 'dev':
      return devConfig;
    case 'staging':
      return stagingConfig;
    case 'testing':
      return testingConfig;
    case 'demo':
      return demoConfig;
    case 'prod':
      return prodConfig;
    default:
      throw new Error(
        `Unknown REACT_APP_STAGE env was used in app configuration: ${ENV_PRINT}`
      );
  }
};

const config: AppConfig = {
  pollingInterval: 120000, // 2min
  gaTrackingId: process.env.GA_ID || '',
  ...getConfig(),
};

export default config;
